import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = {
  class: "container"
};
var _hoisted_2 = {
  class: "content-class"
};
var _hoisted_3 = {
  class: "number-panel mrg16"
};
var _hoisted_4 = {
  class: "body mrg16"
};
var _hoisted_5 = {
  class: "body-item"
};
var _hoisted_6 = {
  key: 0,
  class: "flex-center"
};
var _hoisted_7 = {
  class: "body-item mrg16"
};
var _hoisted_8 = {
  key: 0,
  class: "flex-center"
};
var _hoisted_9 = {
  class: "number-panel mrg16"
};
var _hoisted_10 = {
  class: "body-study mrg16"
};
var _hoisted_11 = {
  class: "body-study-left"
};
var _hoisted_12 = {
  class: "text-box"
};
var _hoisted_13 = {
  class: "text-list"
};
var _hoisted_14 = {
  class: "body-study-right"
};
var _hoisted_15 = {
  key: 0,
  class: "flex-center"
};
import { storeToRefs } from 'pinia';
import { reactive, computed, nextTick, onMounted } from 'vue';
import { ref } from 'vue';
import { getClassTeacher, getGroupAndMemberDetail, getLearningResultsAndQuality, getParticipationRate, getPraiseCount, getStudentCompare, getTimeTeacherPeriod } from '@/api/index-guan';
import Empty from '@/components/Empty/index.vue';
import FormItem from '../components/lib/FormItem';
import mTable from '../components/lib/Table';
import { TABLE_HEAD } from '../components/const/table';
import useUserStore from '@/stores/modules/user';
import analysisTab from '../components/analysisTab.vue';
import PageSearch from '../components/PageSearch.vue';
import teacherOverviewPanel from '../components/teacherOverviewPanel.vue';
import teachTab from '../components/teachTab.vue';
import barLineAnalysis from '../echarts/barLineAnalysis';
import dobarAnalysis from '../echarts/dobarAnalysis';
import onlyLineAnalysis from '../echarts/onlyLineAnalysis.vue';
import scatterAnalysis from '../echarts/scatterAnalysis';
export default {
  __name: 'teacher',
  setup: function setup(__props) {
    var classTypeOptions = [{
      label: '行政班',
      value: 3
    }, {
      label: '教学班',
      value: 4
    }]; // 班级类型
    var classOptions = ref([]); // 班级
    var cycleOptions = ref([]); /// / 时间周期
    var groupOptions = ref([]); // 小组数据
    var classType = ref(3);
    var classRoom = ref('');
    var cycle = ref('');
    var userStore = useUserStore();
    var _storeToRefs = storeToRefs(userStore),
      userInfo = _storeToRefs.userInfo;
    var teacherOverviewRef = ref(null);
    var emptyImage = require('@/assets/home/dataReport/images/empty-chart.png');
    var emptyDataImage = require('@/assets/home/dataReport/images/empty-data.png');
    // 存储各个接口返回的总体数据
    var states = reactive({
      participationRate: {},
      // 参与率
      praiseCount: {},
      // 获赞数-课堂成果提交数
      interactData: {},
      // 互动与参与
      allLearningResults: {},
      // 学习成果与质量
      LearningResults: {},
      // 小组数据
      loading_participationRate: true,
      loading_praiseCount: true,
      loading_allLearningResults: true
    });
    // 小组
    var studyGroupId = ref([]);
    var showPartic = computed(function () {
      var series = states.participationRate.series;
      if (!series) {
        return false;
      }
      var isNowNone = series.some(function (item) {
        var bool = false;
        if (item && item.data.length > 0) {
          bool = item.data.some(function (itm) {
            return itm > 0;
          });
        }
        return bool;
      });
      return isNowNone;
    });
    var showPraise = computed(function () {
      var series = states.praiseCount.series;
      if (!series) {
        return false;
      }
      var isNowNone = series.some(function (item) {
        var bool = false;
        if (item && item.data.length > 0) {
          bool = item.data.some(function (itm) {
            return itm > 0;
          });
        }
        return bool;
      });
      return isNowNone;
    });
    var showLeanAndQ = computed(function () {
      var baseStaticPVO = states.LearningResults.baseStaticPVO;
      if (!baseStaticPVO) {
        return false;
      }
      var series = baseStaticPVO.series;
      if (!series) {
        return false;
      }
      var isNowNone = series.some(function (item) {
        var bool = false;
        if (item && item.data.length > 0) {
          bool = item.data.some(function (itm) {
            return itm > 0;
          });
        }
        return bool;
      });
      return isNowNone;
    });
    // 获取图标数据
    var getAnalysisData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              // if (!classRoom.value || !cycle.value) return
              data = {
                classRoom: classRoom.value,
                cycle: cycle.value
              }; // 获取学生对比数据
              studyGroupId.value = [];
              groupOptions.value = [];
              _context.n = 1;
              return getStudentCompare(data).then(function (res) {
                if (res.data.data && res.data.data.length > 0) {
                  groupOptions.value = res.data.data;
                  groupOptions.value.forEach(function (element, index) {
                    if (index < 3) {
                      studyGroupId.value.push(element.name);
                    }
                  });
                }
              });
            case 1:
              states.loading_allLearningResults = true;
              states.loading_participationRate = true;
              states.loading_praiseCount = true;
              // 参与展示率
              getParticipationRate(data).then(function (res) {
                states.loading_participationRate = false;
                // console.log(res)
                states.participationRate = res.data.data;
                states.participationRate.title = '';
              });
              // 获赞数-课堂成果提交数
              getPraiseCount(data).then(function (res) {
                states.loading_praiseCount = false;
                states.praiseCount = res.data.data;
                states.praiseCount.showLegend = true;
              });
              // 互动与参与
              /* getInteractionAndParticipation(data).then((res) => {
                 states.interactData = res.data.data
               })*/
              // 学习成果与质量
              getLearningResultsAndQuality(data).then(function (res) {
                states.loading_allLearningResults = false;
                states.allLearningResults = res.data.data;
                dealGetSuitLearningData();
              });
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function getAnalysisData() {
        return _ref.apply(this, arguments);
      };
    }();

    // 获取符合条件的数据
    var dealGetSuitLearningData = function dealGetSuitLearningData() {
      var _states$allLearningRe = states.allLearningResults,
        baseStaticPVO = _states$allLearningRe.baseStaticPVO,
        learningAndQualityInfos = _states$allLearningRe.learningAndQualityInfos;
      var legend = baseStaticPVO.legend,
        series = baseStaticPVO.series;
      var newBaseData = {
        legend: legend.filter(function (item) {
          return studyGroupId.value.includes(item);
        }),
        series: series.filter(function (item) {
          return studyGroupId.value.find(function (itm) {
            return item.name === itm;
          });
        })
      };
      var newLearningData = learningAndQualityInfos.filter(function (item) {
        var findData = studyGroupId.value.findIndex(function (itm) {
          return item.name === itm + '正答率';
        });
        // console.log(item,studyGroupId.value,findData)
        return findData > -1;
      });
      // console.log(newLearningData,240)
      states.LearningResults = {
        baseStaticPVO: newBaseData,
        learningAndQualityInfos: newLearningData
      };
    };
    // 修改学习小组数据
    var handleChangeGroup = function handleChangeGroup() {
      dealGetSuitLearningData();
    };
    var classTypeName = computed(function () {
      var _classTypeOptions$fin;
      return (_classTypeOptions$fin = classTypeOptions.find(function (item) {
        return item.value === classType.value;
      })) === null || _classTypeOptions$fin === void 0 ? void 0 : _classTypeOptions$fin.label;
    });
    var className = computed(function () {
      var _classOptions$value$f;
      return (_classOptions$value$f = classOptions.value.find(function (item) {
        return item.value === classRoom.value;
      })) === null || _classOptions$value$f === void 0 ? void 0 : _classOptions$value$f.label;
    });

    // 表格数据
    var columns = ref(TABLE_HEAD.teacherColumn);
    var tdata = ref([]);
    var size = ref(20);
    var current = ref(1);
    var groupId = ref('');
    var studentId = ref('');
    var total = ref(0);
    // 获取教师授课详情
    var getGroupAndMemberData = function getGroupAndMemberData() {
      var data = {
        classRoom: classRoom.value,
        cycle: cycle.value,
        groupId: groupId.value,
        studentId: studentId.value,
        size: size.value,
        current: current.value
      };
      getGroupAndMemberDetail(data).then(function (res) {
        // console.log(res.data.data, 272)
        tdata.value = res.data.data.records.map(function (item) {
          item.studentRate = item.studentRate + '%';
          item.detectionRate = item.detectionRate + '%';
          return item;
        });
        total.value = res.data.data.total;
      });
    };

    // 切换有无，班级数据信息 获取教师授课详情
    var handleChangeTab = function handleChangeTab(val) {
      // console.log(val)
      groupId.value = val.groupId;
      studentId.value = val.studentId;
      size.value = 20;
      current.value = 1;
      getGroupAndMemberData();
    };
    var changePageSize = function changePageSize(val) {
      current.value = 1;
      size.value = val;
      getGroupAndMemberData();
    };
    var changeCurrent = function changeCurrent(num) {
      current.value = num;
      getGroupAndMemberData();
    };

    // 修改班级，时间周期
    var handleChange = function handleChange() {
      defaultGetData();
    };

    // 获取班级数据
    var getClassTeacherData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _userInfo$value;
        var data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              // console.log('todo', userInfo.value.id)
              data = {
                userId: (_userInfo$value = userInfo.value) === null || _userInfo$value === void 0 ? void 0 : _userInfo$value.id,
                classType: classType.value
              };
              _context2.n = 1;
              return getClassTeacher(data).then(function (res) {
                if (res.data.data && res.data.data.length > 0) {
                  classOptions.value = res.data.data;
                  classRoom.value = classOptions.value[0].value;
                } else {
                  classOptions.value = [];
                  classRoom.value = '';
                }
              });
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function getClassTeacherData() {
        return _ref2.apply(this, arguments);
      };
    }();
    // 修改班级类型
    var handleChangeClass = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return getClassTeacherData();
            case 1:
              defaultGetData();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function handleChangeClass() {
        return _ref3.apply(this, arguments);
      };
    }();
    var defaultGetData = function defaultGetData() {
      // 展示率，本周课堂情况
      // 互动与参与
      getAnalysisData();
      // 教师授课详情
      size.value = 20;
      current.value = 1;
      getGroupAndMemberData();
      // 总体概览
      nextTick(function () {
        teacherOverviewRef.value.getPanelOverview();
      });
    };

    // 获取周期
    var getTimeTeacherPeriodData = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return getTimeTeacherPeriod().then(function (res) {
                if (res.data.data) {
                  cycleOptions.value = res.data.data;
                  cycle.value = res.data.data[0].value;
                } else {
                  cycleOptions.value = [];
                }
              });
            case 1:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      return function getTimeTeacherPeriodData() {
        return _ref4.apply(this, arguments);
      };
    }();
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            _context5.n = 1;
            return getClassTeacherData();
          case 1:
            _context5.n = 2;
            return getTimeTeacherPeriodData();
          case 2:
            defaultGetData();
          case 3:
            return _context5.a(2);
        }
      }, _callee5);
    })));
    return function (_ctx, _cache) {
      var _component_t_select = _resolveComponent("t-select");
      var _component_Loading = _resolveComponent("Loading");
      var _component_svg_icon = _resolveComponent("svg-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(PageSearch, null, {
        default: _withCtx(function () {
          return [_createVNode(_unref(FormItem), null, {
            formLabel: _withCtx(function () {
              return _toConsumableArray(_cache[4] || (_cache[4] = [_createTextVNode(" 班级类型 ", -1)]));
            }),
            formInput: _withCtx(function () {
              return [_createVNode(_component_t_select, {
                modelValue: classType.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return classType.value = $event;
                }),
                options: classTypeOptions,
                onChange: handleChangeClass
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          }), _createVNode(_unref(FormItem), null, {
            formLabel: _withCtx(function () {
              return _toConsumableArray(_cache[5] || (_cache[5] = [_createTextVNode(" 班级 ", -1)]));
            }),
            formInput: _withCtx(function () {
              return [_createVNode(_component_t_select, {
                modelValue: classRoom.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                  return classRoom.value = $event;
                }),
                keys: {
                  label: 'name',
                  value: 'value'
                },
                options: classOptions.value,
                onChange: handleChange
              }, null, 8, ["modelValue", "options"])];
            }),
            _: 1
          }), _createVNode(_unref(FormItem), null, {
            formLabel: _withCtx(function () {
              return _toConsumableArray(_cache[6] || (_cache[6] = [_createTextVNode(" 时间周期 ", -1)]));
            }),
            formInput: _withCtx(function () {
              return [_createVNode(_component_t_select, {
                modelValue: cycle.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                  return cycle.value = $event;
                }),
                keys: {
                  label: 'name',
                  value: 'value'
                },
                options: cycleOptions.value,
                onChange: handleChange
              }, null, 8, ["modelValue", "options"])];
            }),
            _: 1
          })];
        }),
        _: 1
      })]), _createElementVNode("div", _hoisted_3, [_createVNode(teacherOverviewPanel, {
        ref_key: "teacherOverviewRef",
        ref: teacherOverviewRef,
        cycle: cycle.value,
        classRoom: classRoom.value,
        class: "mrg16"
      }, null, 8, ["cycle", "classRoom"]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [states.loading_participationRate ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_Loading)])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [showPartic.value ? (_openBlock(), _createBlock(_unref(scatterAnalysis), {
        key: 0,
        id: "echart1",
        data: states.participationRate
      }, null, 8, ["data"])) : (_openBlock(), _createBlock(Empty, {
        key: 1,
        "full-height": true,
        icon: _unref(emptyImage)
      }, null, 8, ["icon"]))], 64))]), _createElementVNode("div", _hoisted_7, [states.loading_praiseCount ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_Loading)])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [showPraise.value ? (_openBlock(), _createBlock(_unref(barLineAnalysis), {
        key: 0,
        id: "echart2",
        yAxis1: "获赞数",
        yAxis2: "提交数",
        data: states.praiseCount
      }, null, 8, ["data"])) : (_openBlock(), _createBlock(Empty, {
        key: 1,
        "full-height": true,
        icon: _unref(emptyImage)
      }, null, 8, ["icon"]))], 64))])])]), _createElementVNode("div", _hoisted_9, [_createVNode(analysisTab, {
        "is-flex": true
      }, {
        title: _withCtx(function () {
          return _toConsumableArray(_cache[7] || (_cache[7] = [_createTextVNode(" 学习成果与质量 ", -1)]));
        }),
        "right-slot": _withCtx(function () {
          return [_createVNode(_unref(FormItem), {
            "has-margin": false
          }, {
            formLabel: _withCtx(function () {
              return _toConsumableArray(_cache[8] || (_cache[8] = [_createTextVNode(" 选择对比 ", -1)]));
            }),
            formInput: _withCtx(function () {
              return [_createVNode(_component_t_select, {
                modelValue: studyGroupId.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                  return studyGroupId.value = $event;
                }),
                style: {
                  "min-width": "200px"
                },
                keys: {
                  label: 'name',
                  value: 'name'
                },
                max: 4,
                options: groupOptions.value,
                multiple: "",
                onChange: handleChangeGroup
              }, null, 8, ["modelValue", "options"])];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_svg_icon, {
        class: "img-svg",
        size: "60",
        name: "image-circel"
      }), _cache[10] || (_cache[10] = _createElementVNode("div", {
        class: "cover"
      }, null, -1)), _createElementVNode("div", _hoisted_12, [_cache[9] || (_cache[9] = _createElementVNode("div", {
        class: "text-month"
      }, "本月内", -1)), _createElementVNode("div", _hoisted_13, [states.LearningResults && states.LearningResults.learningAndQualityInfos && states.LearningResults.learningAndQualityInfos.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(states.LearningResults.learningAndQualityInfos, function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "text-item"
        }, [_createElementVNode("div", null, _toDisplayString(item.name), 1), _createElementVNode("div", null, _toDisplayString(item.value + '%'), 1)]);
      }), 128)) : (_openBlock(), _createBlock(Empty, {
        key: 1,
        class: "empty-class",
        "full-height": true,
        icon: _unref(emptyDataImage),
        size: 70
      }, null, 8, ["icon"]))])])]), _createElementVNode("div", _hoisted_14, [states.loading_allLearningResults ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(_component_Loading)])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [showLeanAndQ.value ? (_openBlock(), _createBlock(onlyLineAnalysis, {
        key: 0,
        id: "echart4",
        data: states.LearningResults.baseStaticPVO
      }, null, 8, ["data"])) : (_openBlock(), _createBlock(Empty, {
        key: 1,
        "full-height": true,
        icon: _unref(emptyImage)
      }, null, 8, ["icon"]))], 64))])])])]);
    };
  }
};